<template>
  <div
    class="has-background-white"
    style="border-top: 4px solid #276cda; margin-bottom: 1rem"
  >
    <div class="container">
      <nav class="navbar" role="navigation" aria-label="main navigation">
        <div class="navbar-brand">
          <p class="navbar-item is-size-4">{{ $t("topbar.account") }}</p>
          <a
            role="button"
            class="navbar-burger burger"
            aria-label="menu"
            aria-expanded="false"
            data-target="topbar"
            :class="{ 'is-active': showMenu }"
            @click="toggleMenu()"
          >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>
        <div id="topbar" class="navbar-menu" :class="{ 'is-active': showMenu }">
          <div class="navbar-start"></div>
          <div class="navbar-end">
            <div class="navbar-item">
              <mat-icon icon="mdi-account"></mat-icon>
              <span>{{ username }}</span>
            </div>
            <a class="navbar-item" @click="signOut()">
              <mat-icon icon="mdi-exit-to-app"></mat-icon>
              <span>{{ $t("topbar.sign_out") }}</span>
            </a>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>
<script>
import MatIcon from "@/components/MatIcon.vue";
import { mapGetters, mapActions } from "vuex";
import { userManager } from "@/auth.service";
import qs from "qs";
import axios from "axios";
import { appSettings } from "@/app.settings";
import guid from "@/guid";
export default {
  name: "Topbar",
  components: {
    MatIcon,
  },
  computed: {
    ...mapGetters(["username", "isAuthenticated"]),
  },
  data() {
    return {
      showMenu: false,
    };
  },
  methods: {
    ...mapActions(["removeUser"]),
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    postLogout() {
      let url = appSettings.authority + "/oauth2/end_session";
      if (appSettings.publicPath) {
        url = "/oauth2/end_session";
      }
      const id = guid.newGuid();
      axios
        .post(
          url,
          qs.stringify({
            id_token_hint: this.$store.state.idToken,
            state: id,
          }),
          {
            headers: {
              "content-type": "application/x-www-form-urlencoded;charset=utf-8",
            },
          }
        )
        .then(
          (resp) => {
            if (id === resp.data.state) {
              this.$store.dispatch("removeUser");
              userManager.signinRedirect();
            }
          },
          (err) => {
            console.log(err);
            this.$store.dispatch("removeUser");
            userManager.signinRedirect();
          }
        );
    },
    redirectLogout() {
      let publicPath = "";
      if (appSettings.publicPath) {
        publicPath = appSettings.publicPath;
      }
      let redirectURL = new URL(publicPath+"/oauth2/end_session", appSettings.authority);
      redirectURL.searchParams.append(
        "id_token_hint",
        this.$store.state.idToken
      );
      this.$store.dispatch("removeUser");
      window.location.href = redirectURL.href;
    },
    signOut() {
      if (appSettings.logoutViaRedirect) {
        this.redirectLogout();
      } else {
        this.postLogout();
      }
    },
  },
};
</script>
